export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Richiesta conferma"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["L'autorizzazione deve essere confermata con una chiave monouso"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["L'autorizzazione deve essere confermata con una parola magica"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["La registrazione deve essere confermata con un codice inviato via SMS"])}
}